/* eslint-disable react-hooks/exhaustive-deps */
import { Typography, Box } from '@mui/material'
import { useEffect, useState } from 'react'
import { useCrudForm } from '../../api/useCrudForm';
import { endpoints } from '../../api/endpoints';
import { ControlledInput } from '../../components/forms/input/ControlledInput';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from "yup";
import { useForm } from 'react-hook-form';
import { LoadingButton } from '@mui/lab';
import { toast } from 'react-toastify';
import PenaltyRateTable from './PenaltyRateTable';

const BaseRate = () => {
    const [loading, setLoading] = useState(false)
    const [penaltyList, setPenaltyList] = useState()
    const { get, add } = useCrudForm();
    const [baseRate, setBaseRate] = useState<any>()
    const [skip, setSkip] = useState(0)
    const [count, setCount] = useState<any>(0);
    const [take, setTake] = useState(10)

    const { handleSubmit, control, formState: { errors, }, reset } = useForm(
        {
            resolver: yupResolver(schema),
            defaultValues: { rate: '' }
        }
    )

    const fetchData = () => {
        get({
            endpoints: `${endpoints.penaltyRate.get}`,
            onSuccess: (data: any) => {
                setBaseRate(data.data ?? 0)
            },
            onError: (error: any) => {
                setBaseRate(0)
                console.log(error)
            }
        })
    }

    useEffect(() => {
        fetchData()
    }, [])

    const postData = (values: any) => {
        setLoading(true)
        add({
            endpoints: `${endpoints.penaltyRate.add}`,
            onSuccess: (data: any) => {
                toast.success(data.message, { style: { background: '#3150A1' } })
                setLoading(false)
                fetchData()
                refetchData()
                reset()
            },
            onError: (error: any) => {
                setLoading(false)
            },
            values: values
        })
    }

    const refetchData = () => {
        setLoading(true)
        get({
            endpoints: endpoints.penaltyRate.list({ skip: skip * take, take, }),
            onSuccess: (data: any) => {
                setPenaltyList(data.data.list)
                setCount(data.data.count)
                setLoading(false)
                fetchData()
            },
            onError: (error: any) => {
                console.log(error)
                setLoading(false)
            }
        })
    }

    return (
        <>
            <Typography variant="h5" component="h5" mb={1} fontWeight={600}>Penalty Rate</Typography>
            <Box sx={{ width: "100%", padding: "24px 12px", background: "white", borderRadius: "5px" }} my={2}>
                <Typography component={'p'} mt={4} mb={2}>Current Penalty Rate : <Typography component={'span'} style={{ fontWeight: 'bold' }}>{baseRate?.rate ?? 'N/A'}</Typography></Typography>

                <Box style={{ display: 'flex', }}>
                    <ControlledInput type='number' width={"260px"} name="rate" control={control} errors={errors} label="Penalty Rate" size={'small'} />
                    <LoadingButton loading={loading} onClick={(e) => { e.preventDefault(); handleSubmit(postData)() }} variant="contained" sx={{ marginLeft: '16px', height: '40px', backgroundColor: '#3150A1', '&:hover': { backgroundColor: '#3150A1' } }} >Add</LoadingButton>
                </Box>
                <Box sx={{ width: "100%", padding: "24px 0", background: "white", borderRadius: "5px" }} my={2}>
                    <PenaltyRateTable rows={penaltyList} refetchData={refetchData} loading={loading} setLoading={setLoading} skip={skip} take={take} setTake={setTake} setSkip={setSkip} count={count} />
                </Box>
            </Box>
        </>
    )
}

export default BaseRate

const schema = Yup.object().shape({
    rate: Yup.number().typeError('Required').required('Required').notOneOf([0], 'Required'),
});